// Complete, same-date fictional equity portfolios. Percent weights sum to 100.
export const researchHoldings = [
  { id: 'alpha', name: '甲公司', a: 60, b: 20 },
  { id: 'beta', name: '乙公司', a: 25, b: 0 },
  { id: 'gamma', name: '丙公司', a: 0, b: 70 },
  { id: 'delta', name: '丁公司', a: 15, b: 10 },
];
export function fundExposure(weightA = 50, alphaReturn = -30) {
  if (typeof weightA !== 'number' || !Number.isFinite(weightA) || weightA < 0 || weightA > 100
    || typeof alphaReturn !== 'number' || !Number.isFinite(alphaReturn) || alphaReturn < -100 || alphaReturn > 100) return null;
  const rows = researchHoldings.map(row => ({ ...row, combined: weightA / 100 * row.a + (1 - weightA / 100) * row.b }));
  const overlap = rows.reduce((sum, row) => sum + Math.min(row.a, row.b), 0);
  const portfolioReturn = rows[0].combined / 100 * alphaReturn;
  return { rows, overlap, uniqueHoldings: rows.filter(row => row.combined > 1e-9).length,
    portfolioReturn: portfolioReturn === 0 ? 0 : portfolioReturn, endValue: 100000 * (1 + portfolioReturn / 100) };
}
